import React, { useState, useEffect, useRef } from "react";

//STYLE
import {
  SelectInputContainer,
  SelectInput,
  Modal,
  ModalContent,
  CheckboxLabel,
  CustomCheckbox,
  ImgArrow,
} from "./SelectInputFilterStyled";

// LIBRARIES

import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

// ASSETS

import filledCheckbox from "assets/svg/filledCheckbox.svg";
import emptyCheckbox from "assets/svg/emptyCheckbox.svg";
import arrowDown from "assets/svg/ArrowDownBurgundy.svg";
import yellowArrowDown from "assets/svg/ArrowDownYellow.svg";

//MISC

import { EventTypes, CheckProps, UsageType } from "./SelectInputFilterModel";
import { TextType } from "../CustomText/CustomTextModel";
import { COLORS } from "constants/variables";

// REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

//COMPONENTS

import CustomText from "../CustomText/CustomText";

const SelectInputComponent = ({ type = UsageType.default, checkedState, setCheckedState }) => {
  //PROPS

  //STATE CONST
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const modalRef = useRef<HTMLDivElement>(null);
  // const [checkedState, setCheckedState] = useState<CheckProps>({
  //   allEvents: true,
  //   dsuEvents: false,
  //   partnerEvents: false,
  // });

  const [selectedText, setSelectedText] = useState<string>(
    t("view.newsAndMedia.events.filters.allEvents")
  );

  const filterOptions = [
    {
      type: EventTypes.AllEvents,
      text: t("view.newsAndMedia.events.filters.allEvents"),
    },
    {
      type: EventTypes.DsuEvents,
      text: t("view.newsAndMedia.events.filters.DsuEvents"),
    },
    {
      type: EventTypes.PartnerEvents,
      text: t("view.newsAndMedia.events.filters.partnerEvents"),
    },
  ];

  //LIBRARY CONST

  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  //LIFECYCLE
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setIsModalOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  //LIBRARY
  const isTablet = useMediaQuery({ maxWidth: 1400 });

  //HANDLE EVENTS

  const handleSelectClick = (isOpen) => {
    if (isOpen === true) setIsModalOpen(false);
    else setIsModalOpen(true);
  };

  const handleCheckboxClick = (type, text) => {
    setCheckedState({
      allEvents: false,
      dsuEvents: false,
      partnerEvents: false,
      [type]: true,
    });
    setSelectedText(text);
    setIsModalOpen(false);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <SelectInputContainer type={type} biggerCursor={biggerCursor}>
      <SelectInput
        type={type}
        onClick={() => handleSelectClick(isModalOpen)}
        ref={modalRef}
        isOpen={isModalOpen}
        biggerCursor={biggerCursor}
      >
        <CustomText
          text={selectedText}
          type={TextType.P2}
          color={COLORS.MetalicSilver}
        />
        <ImgArrow
          src={
            isTablet || type === UsageType.girdle ? yellowArrowDown : arrowDown
          }
          isRotated={isModalOpen}
        />
        {isModalOpen && (
          <Modal type={type} onClick={stopPropagation}>
            <ModalContent type={type} biggerCursor={biggerCursor}>
              {!isTablet && (
                <CustomText
                  text={t("view.newsAndMedia.events.filters.select")}
                  type={TextType.H5bold}
                  color={
                    type === UsageType.girdle
                      ? COLORS.Background
                      : COLORS.MetalicSilver
                  }
                />
              )}

              {filterOptions.map((option) => (
                <CheckboxLabel
                  key={option.type}
                  onClick={() => handleCheckboxClick(option.type, option.text)}
                  biggerCursor={biggerCursor}
                >
                  <CustomText
                    text={option.text}
                    type={TextType.P2}
                    color={
                      type === UsageType.girdle
                        ? COLORS.Background
                        : COLORS.MetalicSilver
                    }
                  />
                  <CustomCheckbox
                    biggerCursor={biggerCursor}
                    image={
                      checkedState[option.type] ? filledCheckbox : emptyCheckbox
                    }
                  />
                </CheckboxLabel>
              ))}
            </ModalContent>
          </Modal>
        )}
      </SelectInput>
    </SelectInputContainer>
  );
};

export default SelectInputComponent;
